import React from 'react';
import ProductCard from './ProductCard';
import styles from './ProductGrid.module.css';

const ProductGrid = ({ products }) => {
  const formattedProducts = products.map(product => ({
    ...product,
    primary_image: product.primary_image || '/placeholder-image.jpg'
  }));

  return (
    <div className={styles.grid}>
      {formattedProducts.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default ProductGrid;

